import { ENVIRONMENTS, envKeyOf, tint } from "@/lib/environments";

export const EnvBadge = ({ ws, envKey, size = "sm" }) => {
  const key = envKey || envKeyOf(ws);
  const env = ENVIRONMENTS[key];
  if (!env) return null;
  const cls = size === "md" ? "text-sm px-3 py-1" : "text-[11px] px-2 py-0.5";
  return (
    <span
      data-testid={`env-badge-${key}`}
      className={`inline-flex items-center gap-1 rounded-full font-semibold shrink-0 ${cls}`}
      style={{ backgroundColor: tint(env.color, 0.18), color: env.text }}
    >
      <span aria-hidden>{env.emoji}</span> {env.label}
    </span>
  );
};
